import { React, useState, useEffect } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox, Tooltip } from "antd";
import Iconmoon from "../../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  ProductionSet,
} from "../../../styledElements";
import RightDrawerSidebar from "../../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import { DatePickerY, GlobalSet, DisabledStyles } from "../../../pageStyled";
import {
  getParentReelDetailsById,
  getCuttingParentReelDetailsById,
} from "../../../../Services/productionPlanningServices";
import moment from "moment";
import {
  lengthUnit,
  weightUnit,
} from "../../../../Utils/Constant/MeasurementUnitList";
import { toHandlePOName } from "../../../../Utils/helper/helper";
const { Option } = Select;
const { TextArea } = Input;

const JumboReelParentSetDrawer = ({
  parentReelId,
  visible,
  onClose,
  isProduced = false,
  jobcardType,
  type,
}) => {
  const [parentReelDetails, setParentReelDetails] = useState();
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [form] = Form.useForm();

  const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);

  const showProductionStatus = (status) => {
    return capitalize(
      status === "open"
        ? "Not Mapped"
        : status === "cancel"
        ? "Cancelled"
        : status
    );
  };

  useEffect(() => {
    form.resetFields();
    if (parentReelId) {
      getParentReelDetailsById(parentReelId)
        .then((response) => {
          const data = response.data.data;
          data.reels = data.reels.map((item) =>
           item.category === "so"
                           ? { ...item, customer: ["SO"], consignee: ["SO"],so:toHandlePOName(item.so) }
                           :{...item,po:toHandlePOName(item.po)}
          );
          setParentReelDetails(data);
        })
        .catch((error) => console.log(error));
    }
  }, []);

  return parentReelDetails ? (
    <>
      {jobcardType == "single_stage" ? (
        <RightDrawerSidebar
          title={
            parentReelDetails?.machine_type === "cutter"
              ? `Parent Set - ${parentReelDetails.id}`
              : `Parent Reel - ${parentReelDetails.id}`
          }
          visible={visible}
          onClose={onClose}
        >
          <RightDrawerContainer>
            <div className="resetPassForm removePadLeft">
              <DetailFields className="marginBtnP">
                <Form
                  form={form}
                  name="basic"
                  autoComplete="off"
                  className="haberLogin haberSignup"
                  style={{ marginTop: "0" }}
                >
                  <div
                    className="drawerField"
                    style={{ paddingTop: "5px", paddingBottom: "10px" }}
                  >
                    <div className="titleWithText">
                      <h5 style={{ paddingBottom: "13px" }}>General Details</h5>
                      {parentReelDetails?.machine_type !== "cutter" && (
                        <p style={{ marginTop: "-10px" }}>
                          Reel / Core Diameter: {parentReelDetails.reel_od}{" "}
                          {parentReelDetails?.units &&
                          parentReelDetails?.units?.reel_od
                            ? lengthUnit[
                                parentReelDetails.units.reel_od
                              ]?.displayName.toUpperCase()
                            : ""}
                          {" / "}
                          {parentReelDetails.core_id}{" "}
                          {parentReelDetails?.units &&
                          parentReelDetails?.units?.core_id
                            ? lengthUnit[
                                parentReelDetails.units.core_id
                              ]?.displayName.toUpperCase()
                            : ""}
                        </p>
                      )}
                      <p style={{ marginTop: "-10px" }}>
                        Weight: {parentReelDetails.weight?.toFixed(3)}{" "}
                        {parentReelDetails?.units &&
                        parentReelDetails?.units?.parent_roll_weight
                          ? capitalize(
                              weightUnit[
                                parentReelDetails.units.parent_roll_weight
                              ]?.displayName
                            )
                          : "T"}
                      </p>
                      <p style={{ marginTop: "-10px" }}>Mapped Jumbo:</p>
                      {/* <br /> */}
                      {parentReelDetails?.mapped_jumbo_reels_info?.map(
                        (item) => (
                          <p style={{ marginTop: "-10px" }}>
                            {`${item.number} (${item.weight_utilized} ${" "} ${
                              item?.units && item?.units?.weight_utilized
                                ? capitalize(
                                    weightUnit[item.units.weight_utilized]
                                      ?.displayName
                                  )
                                : "T"
                            })`}
                          </p>
                        )
                      )}
                    </div>
                  </div>
                  {(parentReelDetails.status === "mapped" ||
                    parentReelDetails.status === "produced") && (
                    <>
                      <div className="drawerField">
                        {parentReelDetails?.machine_type !== "cutter" ? (
                          <div className="titleWithText">
                            <h5>Rewinding Date & Shift</h5>
                            <p>
                              The reel was rewinded on selected date and shift
                            </p>
                          </div>
                        ) : (
                          <div className="titleWithText">
                            <h5>Cutting Date & Shift</h5>
                            <p>
                              The sheet will be cut on selected date and shift
                            </p>
                          </div>
                        )}
                        {parentReelDetails.machine_type === "rewinder" ? (
                          <Row className="centerAlign justifyCSBetween">
                            <Col span={12}>
                              <DatePickerY>
                                <Form.Item
                                  name="date"
                                  className="dBlock"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This is a mandatory field",
                                    },
                                  ]}
                                  initialValue={
                                    parentReelDetails.rewinding_date
                                      ? moment(
                                          parentReelDetails.rewinding_date,
                                          "YYYY-MM-DD"
                                        )
                                      : null
                                  }
                                >
                                  <DatePicker
                                    format={"DD-MM-YYYY"}
                                    disabledDate={(current) => {
                                      return (
                                        current &&
                                        current < moment().subtract(1, "day")
                                      );
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                                <p style={{ marginTop: "-24px" }}>Date</p>
                              </DatePickerY>
                            </Col>
                            <Col span={12}>
                              <div
                                className="boxFormType"
                                style={{
                                  marginTop: "3px",
                                  paddingLeft: "3px",
                                }}
                              >
                                <Form.Item
                                  name="Shift"
                                  rules={[{ required: true }]}
                                  className="dBlock"
                                  initialValue={
                                    parentReelDetails.rewinding_shift
                                  }
                                >
                                  <Input placeholder="Text" disabled />
                                </Form.Item>
                                <p style={{ marginTop: "-26px" }}>Shift</p>
                              </div>
                            </Col>
                          </Row>
                        ) : (
                          <Row className="centerAlign justifyCSBetween">
                            <Col span={12}>
                              <DatePickerY>
                                <Form.Item
                                  name="cuttingDate"
                                  className="dBlock"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This is a mandatory field",
                                    },
                                  ]}
                                  initialValue={
                                    parentReelDetails.cutting_date
                                      ? moment(
                                          parentReelDetails.cutting_date,
                                          "YYYY-MM-DD"
                                        )
                                      : null
                                  }
                                >
                                  <DatePicker
                                    format={"DD-MM-YYYY"}
                                    disabledDate={(current) => {
                                      return (
                                        current &&
                                        current < moment().subtract(1, "day")
                                      );
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                                <p style={{ marginTop: "-24px" }}>Date</p>
                              </DatePickerY>
                            </Col>
                            <Col span={12}>
                              <div
                                className="boxFormType"
                                style={{
                                  marginTop: "3px",
                                  paddingLeft: "3px",
                                }}
                              >
                                <Form.Item
                                  name="cuttingShift"
                                  rules={[{ required: true }]}
                                  className="dBlock"
                                  initialValue={parentReelDetails.cutting_shift}
                                >
                                  <Input placeholder="Text" disabled />
                                </Form.Item>
                                <p style={{ marginTop: "-26px" }}>Shift</p>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                      {parentReelDetails.status === "produced" &&
                      parentReelDetails?.machine_type !== "cutter" ? (
                        <div className="drawerField">
                          <div className="titleWithText">
                            <h5>Production Completion Date</h5>
                            <p>
                              The production was closed on the selected date
                            </p>
                          </div>
                          <div className="boxFormType">
                            <DatePickerY>
                              <Form.Item
                                name="completionDate"
                                initialValue={
                                  parentReelDetails.production_date
                                    ? moment(
                                        parentReelDetails.production_date,
                                        "YYYY-MM-DD"
                                      )
                                    : null
                                }
                              >
                                <DatePicker format={"DD-MM-YYYY"} disabled />
                              </Form.Item>
                            </DatePickerY>
                          </div>
                        </div>
                      ) : (
                        parentReelDetails.status === "produced" &&
                        parentReelDetails?.machine_type === "cutter" && (
                          <div className="drawerField">
                            <div className="titleWithText">
                              <h5>Production Completed Date</h5>
                              <p>
                                The production was closed on the selected date
                              </p>
                            </div>
                            <div className="boxFormType">
                              <DatePickerY>
                                <Form.Item
                                  name="completionDate"
                                  initialValue={
                                    parentReelDetails.production_date
                                      ? moment(
                                          parentReelDetails.production_date,
                                          "YYYY-MM-DD"
                                        )
                                      : null
                                  }
                                >
                                  <DatePicker format={"DD-MM-YYYY"} disabled />
                                </Form.Item>
                              </DatePickerY>
                            </div>
                          </div>
                        )
                      )}
                      {parentReelDetails?.machine_type !== "cutter" ? (
                        <div className="drawerField">
                          <div className="titleWithText">
                            <h5>Reels</h5>
                            <p>
                              All the child reels of this parent reel can be
                              viewed here
                            </p>
                          </div>
                          <div className="prod-reelset">
                            {parentReelDetails?.reels?.map((reel, index) => (
                              <ProductionSet>
                                <div className="prodset-header">
                                  <Iconmoon
                                    icon="tissue-role"
                                    size={28}
                                    color="#EA655B"
                                  />
                                  <div className="prodleft-header">
                                    <h4>
                                      {reel.id}
                                      {reel.forced && (
                                        <span dataset="Priority">Priority</span>
                                      )}

                                      {reel.intermediate_reels && (
                                        <span
                                          style={{
                                            color: "#6a6866",
                                            backgroundColor: "#edebe9",
                                            marginTop: "auto",
                                          }}
                                        >
                                          Intermediate
                                        </span>
                                      )}
                                    </h4>
                                    {reel.reel_type == "order" &&
                                      reel.category != "so" && (
                                        <label>
                                          Delivery Date:{" "}
                                          {reel.delivery_date
                                            ? moment(reel.delivery_date).format(
                                                "DD-MM-YYYY"
                                              )
                                            : ""}
                                        </label>
                                      )}
                                  </div>
                                </div>
                                <div className="prodset-body">
                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>Reel Weight:</h5>
                                      <p>
                                        {reel.weight}{" "}
                                        {reel.units && reel?.units?.weight
                                          ? capitalize(
                                              weightUnit[reel.units.weight]
                                                ?.displayName
                                            )
                                          : "T"}
                                      </p>
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>Reel Size:</h5>
                                      {reel.reel_size}{" "}
                                      {reel?.units && reel?.units?.reel_size
                                        ? lengthUnit[
                                            reel.units.reel_size
                                          ]?.displayName?.toUpperCase()
                                        : "CM"}
                                    </div>
                                  </div>
                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>Length:</h5>
                                      {reel.reel_length}{" "}
                                      {reel?.units && reel?.units?.reel_length
                                        ? lengthUnit[
                                            reel.units.reel_length
                                          ]?.displayName?.toUpperCase()
                                        : "CM"}
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      {jobcardType === "multi_stage" ? (
                                        !reel.intermediate_reels ? (
                                          reel.reel_type == "order" ? (
                                            <>
                                              <h5>Order Size:</h5>
                                              {!reel.intermediate_reels ? (
                                                <p>
                                                  {reel.size}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.size
                                                    ? lengthUnit[
                                                        reel.units.size
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              ) : (
                                                <p>
                                                  {reel.width}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.width
                                                    ? lengthUnit[
                                                        reel.units.width
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                  {" x "}
                                                  {reel.length}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.length
                                                    ? lengthUnit[
                                                        reel.units.length
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              <h5>Stock Size:</h5>
                                              {reel.width > 0 &&
                                              reel.length > 0 ? (
                                                <p>
                                                  {reel.width}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.width
                                                    ? lengthUnit[
                                                        reel.units.width
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                  {" x "}
                                                  {reel.length}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.length
                                                    ? lengthUnit[
                                                        reel.units.length
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              ) : (
                                                <p>
                                                  {reel.size}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.size
                                                    ? lengthUnit[
                                                        reel.units.size
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              )}
                                            </>
                                          )
                                        ) : reel.cutting_pattern.length == 12 ||
                                          reel.cutting_pattern.length == 13 ||
                                          reel.cutting_pattern.length == 14 ? (
                                          <>
                                            <h5>Cutting Pattern:</h5>
                                            <p style={{ width: "101px" }}>
                                              {reel.cutting_pattern}
                                            </p>
                                          </>
                                        ) : (
                                          <>
                                            <h5>Cutting Pattern:</h5>
                                            <p style={{ width: "101px" }}>
                                              <Tooltip
                                                title={reel.cutting_pattern}
                                              >
                                                {" "}
                                                <span
                                                  style={{
                                                    display: "flex",
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  {reel.cutting_pattern[0] +
                                                    reel.cutting_pattern[1] +
                                                    reel.cutting_pattern[2] +
                                                    reel.cutting_pattern[3] +
                                                    reel.cutting_pattern[4] +
                                                    reel.cutting_pattern[5] +
                                                    "..."}{" "}
                                                </span>
                                              </Tooltip>
                                            </p>
                                          </>
                                        )
                                      ) : reel.reel_type == "order" ? (
                                        !reel.intermediate_reels ? (
                                          <>
                                            <h5>Order Size:</h5>
                                            <p>
                                              {reel.size}{" "}
                                              {reel?.units && reel?.units?.size
                                                ? lengthUnit[
                                                    reel.units.size
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                            </p>
                                          </>
                                        ) : (
                                          <>
                                            <h5>Order Size:</h5>
                                            <p>
                                              {reel.width}{" "}
                                              {reel?.units && reel?.units?.width
                                                ? lengthUnit[
                                                    reel.units.width
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                              {" x "}
                                              {reel.length}{" "}
                                              {reel?.units &&
                                              reel?.units?.length
                                                ? lengthUnit[
                                                    reel.units.length
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                            </p>
                                          </>
                                        )
                                      ) : reel.width > 0 && reel.length > 0 ? (
                                        <>
                                          <h5>Stock Size:</h5>
                                          <p>
                                            {reel.width}{" "}
                                            {reel?.units && reel?.units?.width
                                              ? lengthUnit[
                                                  reel.units.width
                                                ]?.displayName?.toUpperCase()
                                              : "CM"}
                                            {" x "}
                                            {reel.length}{" "}
                                            {reel?.units && reel?.units?.length
                                              ? lengthUnit[
                                                  reel.units.length
                                                ]?.displayName?.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </>
                                      ) : (
                                        <>
                                          <h5>Stock Size:</h5>
                                          <p>
                                            {reel.size}{" "}
                                            {reel?.units && reel?.units?.size
                                              ? lengthUnit[
                                                  reel.units.size
                                                ]?.displayName?.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </>
                                      )}
                                    </div>
                                  </div>

                                  {jobcardType === "multi_stage" ? (
                                    !reel.intermediate_reels ? (
                                      reel.reel_type == "order" ? (
                                        <div className="d-flex prodset-sb">
                                          <div className="prodset-dt prod-50">
                                            <h5>PO/SO NO.:</h5>
                                            {/* <p>{reel.po}</p> */}
                                            {reel?.po?.length > 11 ? (
                                              <Tooltip
                                                placement="bottomLeft"
                                                title={reel?.po}
                                              >
                                                <p>
                                                  {reel?.po?.slice(0, 12) +
                                                    "..."}
                                                </p>
                                              </Tooltip>
                                            ) : (
                                              <p>{reel?.po}</p>
                                            )}
                                            {reel?.so?.length > 11 ? (
                                              <Tooltip
                                                placement="bottomLeft"
                                                title={reel?.so}
                                              >
                                                <p>
                                                  {reel?.so?.slice(0, 12) +
                                                    "..."}
                                                </p>
                                              </Tooltip>
                                            ) : (
                                              <p>{reel?.so}</p>
                                            )}
                                          </div>
                                          <div className="prodset-dt prod-50">
                                            <h5>ORDER NO.:</h5>
                                            <p>{reel.order}</p>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="prodset-dt">
                                          <h5>STOCK NO.:</h5>
                                          <p>{`${reel.stock}`}</p>
                                        </div>
                                      )
                                    ) : (
                                      <>
                                        <div className="d-flex prodset-sb">
                                          <div className="prodset-dt prod-50">
                                            <h5>PO/SO NO.:</h5>
                                            {/* <p>{reel.po}</p> */}
                                            <p>
                                              {[
                                                ...(reel?.po || []),
                                                ...(reel?.so || []),
                                              ]
                                                .slice(0, 2)
                                                .map((item, index) => (
                                                  <div key={index}>
                                                    {item?.length > 11 ? (
                                                      <Tooltip
                                                        placement="bottomLeft"
                                                        title={item}
                                                      >
                                                        <p>
                                                          {item.slice(0, 12)}
                                                          ...,
                                                        </p>
                                                      </Tooltip>
                                                    ) : (
                                                      <p>{item},</p>
                                                    )}
                                                  </div>
                                                ))}

                                              {[
                                                ...(reel?.po || []),
                                                ...(reel?.so || []),
                                              ].length > 2 && (
                                                <Tooltip
                                                  title={[
                                                    ...(reel?.po || []),
                                                    ...(reel?.so || []),
                                                  ]
                                                    .slice(2)
                                                    .join(", ")}
                                                >
                                                  <span
                                                    style={{
                                                      display: "flex",
                                                      fontSize: "10px",
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    &{" "}
                                                    {[
                                                      ...(reel?.po || []),
                                                      ...(reel?.so || []),
                                                    ].length - 2}{" "}
                                                    More
                                                  </span>
                                                </Tooltip>
                                              )}
                                            </p>
                                          </div>
                                          <div className="prodset-dt prod-50">
                                            <h5>ORDER NO.:</h5>
                                            {/* <p>{reel.order}</p> */}
                                            <p>
                                              {reel?.order &&
                                                reel?.order?.map(
                                                  (item, index) => {
                                                    return (
                                                      index < 2 && (
                                                        <div>
                                                          {item}{" "}
                                                          {index == 1
                                                            ? "...,"
                                                            : reel?.order
                                                                ?.length > 1
                                                            ? ","
                                                            : ""}
                                                        </div>
                                                      )
                                                    );
                                                  }
                                                )}

                                              {reel?.order &&
                                                reel?.order?.length >= 2 &&
                                                reel.order?.map(
                                                  (item, index) => {
                                                    let tooltipData = "";
                                                    for (
                                                      let index = 2;
                                                      index <
                                                      reel.order?.length;
                                                      index++
                                                    ) {
                                                      const data =
                                                        reel.order[index];
                                                      tooltipData =
                                                        tooltipData +
                                                        data +
                                                        ", ";
                                                    }
                                                    tooltipData =
                                                      tooltipData.substring(
                                                        0,
                                                        tooltipData.length - 1
                                                      );
                                                    return (
                                                      index == 2 && (
                                                        <Tooltip
                                                          title={tooltipData}
                                                        >
                                                          {" "}
                                                          <span
                                                            style={{
                                                              display: "flex",
                                                              fontSize: "10px",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                          >
                                                            &{" "}
                                                            {reel.order.length -
                                                              2}{" "}
                                                            More
                                                          </span>
                                                        </Tooltip>
                                                      )
                                                    );
                                                  }
                                                )}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="prodset-dt">
                                          <h5>STOCK NO.:</h5>
                                          {/* <p>{`${reel.stock}`}</p> */}
                                          <p>
                                            {reel?.stock &&
                                              reel?.stock?.map(
                                                (item, index) => {
                                                  return (
                                                    index < 2 && (
                                                      <div>
                                                        {item}{" "}
                                                        {index == 1
                                                          ? "...,"
                                                          : reel?.stock
                                                              ?.length > 1
                                                          ? ","
                                                          : ""}
                                                      </div>
                                                    )
                                                  );
                                                }
                                              )}

                                            {reel?.stock &&
                                              reel?.stock?.length >= 2 &&
                                              reel.stock?.map((item, index) => {
                                                let tooltipData = "";
                                                for (
                                                  let index = 2;
                                                  index < reel.stock?.length;
                                                  index++
                                                ) {
                                                  const data =
                                                    reel.stock[index];
                                                  tooltipData =
                                                    tooltipData + data + ", ";
                                                }
                                                tooltipData =
                                                  tooltipData.substring(
                                                    0,
                                                    tooltipData.length - 1
                                                  );
                                                return (
                                                  index == 2 && (
                                                    <Tooltip
                                                      title={tooltipData}
                                                    >
                                                      {" "}
                                                      <span
                                                        style={{
                                                          display: "flex",
                                                          fontSize: "10px",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        &{" "}
                                                        {reel.stock.length - 2}{" "}
                                                        More
                                                      </span>
                                                    </Tooltip>
                                                  )
                                                );
                                              })}
                                          </p>
                                        </div>
                                      </>
                                    )
                                  ) : reel.reel_type == "order" ? (
                                    <div className="d-flex prodset-sb">
                                      <div className="prodset-dt prod-50">
                                        <h5>PO/SO NO.:</h5>
                                        {reel?.po?.length > 11 ? (
                                          <Tooltip
                                            placement="bottomLeft"
                                            title={reel?.po}
                                          >
                                            <p>
                                              {reel?.po?.slice(0, 12) + "..."}
                                            </p>
                                          </Tooltip>
                                        ) : (
                                          <p>{reel?.po}</p>
                                        )}
                                        {reel?.so?.length > 11 ? (
                                          <Tooltip
                                            placement="bottomLeft"
                                            title={reel?.so}
                                          >
                                            <p>
                                              {reel?.so?.slice(0, 12) + "..."}
                                            </p>
                                          </Tooltip>
                                        ) : (
                                          <p>{reel?.so}</p>
                                        )}
                                      </div>
                                      <div className="prodset-dt prod-50">
                                        <h5>ORDER NO.:</h5>
                                        <p>{reel.order}</p>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="prodset-dt">
                                      <h5>STOCK NO.:</h5>
                                      <p>{`${reel.stock}`}</p>
                                    </div>
                                  )}

                                  {jobcardType === "multi_stage" ? (
                                    !reel.intermediate_reels ? (
                                      <div className="d-flex prodset-sb">
                                        <div className="prodset-dt prod-50">
                                          <h5>CX:</h5>
                                          <p>{reel.customer} </p>
                                        </div>
                                        <div className="prodset-dt prod-50">
                                          <h5>CNEE:</h5>
                                          <p>{reel.consignee}</p>
                                        </div>
                                      </div>
                                    ) : (
                                      // (reel.reel_type == "order" ? (
                                      <div className="d-flex prodset-sb">
                                        <div className="prodset-dt prod-50">
                                          <h5>CX:</h5>
                                          {/* <p>{reel.customer}{" "}</p> */}
                                          <p>
                                            {reel?.customer &&
                                              reel?.customer?.map(
                                                (item, index) => {
                                                  return (
                                                    index < 2 && (
                                                      <div>
                                                        {item}{" "}
                                                        {index == 1
                                                          ? "...,"
                                                          : reel?.customer
                                                              ?.length > 1
                                                          ? ","
                                                          : ""}
                                                      </div>
                                                    )
                                                  );
                                                }
                                              )}

                                            {reel?.customer &&
                                              reel?.customer?.length >= 2 &&
                                              reel.customer?.map(
                                                (item, index) => {
                                                  let tooltipData = "";
                                                  for (
                                                    let index = 2;
                                                    index <
                                                    reel.customer?.length;
                                                    index++
                                                  ) {
                                                    const data =
                                                      reel.customer[index];
                                                    tooltipData =
                                                      tooltipData + data + ", ";
                                                  }
                                                  tooltipData =
                                                    tooltipData.substring(
                                                      0,
                                                      tooltipData.length - 1
                                                    );
                                                  return (
                                                    index == 2 && (
                                                      <Tooltip
                                                        title={tooltipData}
                                                      >
                                                        {" "}
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            fontSize: "10px",
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          &{" "}
                                                          {reel.customer
                                                            .length - 2}{" "}
                                                          More
                                                        </span>
                                                      </Tooltip>
                                                    )
                                                  );
                                                }
                                              )}
                                          </p>
                                        </div>
                                        <div className="prodset-dt prod-50">
                                          <h5>CNEE:</h5>
                                          {/* <p>{reel.consignee}</p> */}
                                          <p>
                                            {reel?.consignee &&
                                              reel?.consignee?.map(
                                                (item, index) => {
                                                  return (
                                                    index < 2 && (
                                                      <div>
                                                        {item}{" "}
                                                        {index == 1
                                                          ? "...,"
                                                          : reel?.consignee
                                                              ?.length > 1
                                                          ? ","
                                                          : ""}
                                                      </div>
                                                    )
                                                  );
                                                }
                                              )}

                                            {reel?.consignee &&
                                              reel?.consignee?.length >= 2 &&
                                              reel.consignee?.map(
                                                (item, index) => {
                                                  let tooltipData = "";
                                                  for (
                                                    let index = 2;
                                                    index <
                                                    reel.consignee?.length;
                                                    index++
                                                  ) {
                                                    const data =
                                                      reel.consignee[index];
                                                    tooltipData =
                                                      tooltipData + data + ", ";
                                                  }
                                                  tooltipData =
                                                    tooltipData.substring(
                                                      0,
                                                      tooltipData.length - 1
                                                    );
                                                  return (
                                                    index == 2 && (
                                                      <Tooltip
                                                        title={tooltipData}
                                                      >
                                                        {" "}
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            fontSize: "10px",
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          &{" "}
                                                          {reel.consignee
                                                            .length - 2}{" "}
                                                          More
                                                        </span>
                                                      </Tooltip>
                                                    )
                                                  );
                                                }
                                              )}
                                          </p>
                                        </div>
                                      </div>
                                      // ) : (""))
                                    )
                                  ) : reel.reel_type == "order" ? (
                                    <div className="d-flex prodset-sb">
                                      <div className="prodset-dt prod-50">
                                        <h5>CX:</h5>
                                        <p>{reel.customer} </p>
                                      </div>
                                      <div className="prodset-dt prod-50">
                                        <h5>CNEE:</h5>
                                        <p>{reel.consignee}</p>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>Rewinding Position:</h5>
                                      <p>{reel.position} </p>
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>Reel No.:</h5>
                                      <p>{reel.number}</p>
                                    </div>
                                  </div>

                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>Dispatch Date:{""}</h5>
                                      <p>
                                        {reel.dispatch_date
                                          ? moment(reel.dispatch_date).format(
                                              "DD-MM-YYYY"
                                            )
                                          : ""}
                                      </p>
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>Produced:</h5>
                                      <p>
                                        {reel.produced_weight
                                          ? reel.produced_weight +
                                            " " +
                                            (reel.units &&
                                            reel?.units?.produced_weight
                                              ? capitalize(
                                                  weightUnit[
                                                    reel.units.produced_weight
                                                  ]?.displayName
                                                )
                                              : "T")
                                          : " "}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="removeStar"
                                  style={{ marginTop: "22px" }}
                                >
                                  <Row style={{ marginTop: "-15px" }}>
                                    <div>
                                      <Col>
                                        <Form.Item
                                          name={`coreWeight${index}`}
                                          className="dBlock"
                                          initialValue={
                                            reel?.includes_core_weight
                                          }
                                        >
                                          <Checkbox
                                            // onChange={(e) =>
                                            //   onCoreWeightCheck(e, index)
                                            // }
                                            checked={reel?.includes_core_weight}
                                            disabled
                                          ></Checkbox>
                                          <span
                                            style={{
                                              marginLeft: "10px",
                                              fontSize: "13px",
                                              fontFamily:
                                                "var(--sf-pro-display-m)",
                                              color: "#5b5a58",
                                            }}
                                          >
                                            Produced quantity includes core
                                            weight
                                          </span>
                                        </Form.Item>
                                      </Col>
                                    </div>
                                  </Row>
                                  <Row
                                    style={{
                                      marginTop: "-28px",
                                      marginBottom:
                                        reel[index]?.status != "rejected" &&
                                        "-19px",
                                    }}
                                  >
                                    <div>
                                      <Col>
                                        <Form.Item
                                          name={`packagingWeight${index}`}
                                          className="dBlock"
                                          initialValue={
                                            reel?.includes_packaging_weight
                                          }
                                        >
                                          <Checkbox
                                            // onChange={(e) =>
                                            //   onPackagingWeightCheck(e, index)
                                            // }
                                            checked={
                                              reel?.includes_packaging_weight
                                            }
                                            disabled
                                          ></Checkbox>
                                          <span
                                            style={{
                                              marginLeft: "10px",
                                              fontSize: "13px",
                                              fontFamily:
                                                "var(--sf-pro-display-m)",
                                              color: "#5b5a58",
                                            }}
                                          >
                                            Produced quantity includes packaging
                                            weight
                                          </span>
                                        </Form.Item>
                                      </Col>
                                    </div>
                                  </Row>
                                </div>
                                <div
                                  className="prodset-footer"
                                  style={{ marginTop: "-30px" }}
                                >
                                  <label>Production Status</label>
                                  <span
                                    dataset={showProductionStatus(reel.status)}
                                  >
                                    {showProductionStatus(reel.status)}
                                  </span>
                                </div>
                                {reel.status == "rejected" &&
                                  reel.reel_type === "order" && (
                                    <div
                                      className="prodset-footer"
                                      style={{ marginTop: "-5px" }}
                                    >
                                      <label>
                                        Reason:{" "}
                                        {reel.comments.length
                                          ? reel.comments[
                                              reel.comments.length - 1
                                            ]
                                          : " "}
                                      </label>
                                    </div>
                                  )}
                              </ProductionSet>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="drawerField">
                          <div className="titleWithText">
                            <h5>Sheets</h5>
                            <p>
                              All the child sheets of this parent set can be
                              viewed here
                            </p>
                          </div>
                          <div className="prod-reelset">
                            {parentReelDetails?.reels?.map((sheet) => (
                              <ProductionSet>
                                <div className="prodset-header">
                                  <Iconmoon
                                    icon="sheet"
                                    size={28}
                                    color="#EA655B"
                                  />
                                  <div className="prodleft-header">
                                    <h4>
                                      {sheet.id}
                                      {sheet.forced && (
                                        <span dataset="Priority">Priority</span>
                                      )}
                                      {parentReelDetails.cutter_type &&
                                        parentReelDetails.cutter_type ===
                                          "duplex" && (
                                          <span datasetForStation="Station">
                                            {capitalize(
                                              sheet.station.split("_")[0]
                                            ) +
                                              " " +
                                              sheet.station.split("_")[1]}
                                          </span>
                                        )}
                                    </h4>
                                    {sheet.reel_type == "order" &&
                                      sheet.category != "so" && (
                                        <label>
                                          Delivery Date:{" "}
                                          {sheet.delivery_date
                                            ? moment(
                                                sheet.delivery_date
                                              ).format("DD-MM-YYYY")
                                            : ""}
                                        </label>
                                      )}
                                  </div>
                                </div>
                                <div className="prodset-body">
                                  {sheet.reel_type == "order" ? (
                                    <div>
                                      <div className="prodset-dt">
                                        <h5>PO/SO NO.:</h5>
                                        {sheet?.po?.length > 11 ? (
                                          <Tooltip
                                            placement="bottomLeft"
                                            title={sheet?.po}
                                          >
                                            <p>
                                              {sheet?.po?.slice(0, 12) + "..."}
                                            </p>
                                          </Tooltip>
                                        ) : (
                                          <p>{sheet?.po}</p>
                                        )}
                                        {sheet?.so?.length > 11 ? (
                                          <Tooltip
                                            placement="bottomLeft"
                                            title={sheet?.so}
                                          >
                                            <p>
                                              {sheet?.so?.slice(0, 12) + "..."}
                                            </p>
                                          </Tooltip>
                                        ) : (
                                          <p>{sheet?.so}</p>
                                        )}
                                      </div>
                                      <div className="prodset-dt">
                                        <h5>ORDER NO.:</h5>
                                        <p>{sheet.order}</p>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="prodset-dt">
                                      <h5>STOCK NO.:</h5>
                                      <p>{`${sheet.stock}`}</p>
                                    </div>
                                  )}
                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>Size:</h5>
                                      <p>
                                        {sheet.length}
                                        {sheet.length && sheet.width
                                          ? " x "
                                          : ""}
                                        {sheet.width}{" "}
                                        {sheet.length && sheet.width
                                          ? `${
                                              sheet.units && sheet.units.width
                                                ? lengthUnit[
                                                    sheet.units.width
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"
                                            }`
                                          : ""}
                                      </p>
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>Grain:</h5>
                                      <p>{`${
                                        sheet.grain
                                          ? capitalize(sheet.grain)
                                          : ""
                                      }`}</p>
                                    </div>
                                  </div>
                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>Weight:</h5>
                                      <p>
                                        {sheet.weight}{" "}
                                        {sheet.units && sheet.units.weight
                                          ? capitalize(
                                              weightUnit[sheet.units.weight]
                                                ?.displayName
                                            )
                                          : "T"}
                                      </p>
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>Sheets:</h5>
                                      <p>{sheet.no_of_sheets}</p>
                                    </div>
                                  </div>
                                  <div className="prodset-body">
                                    <div className="prodset-dt">
                                      <h5>Produced Sheets:</h5>
                                      <p>{`${
                                        sheet.accepted_no_of_sheets
                                      } (${sheet.accepted_weight.toFixed(
                                        3
                                      )}) ${" "} ${
                                        sheet.units && sheet.units.weight
                                          ? capitalize(
                                              weightUnit[sheet.units.weight]
                                                ?.displayName
                                            )
                                          : "T"
                                      }`}</p>
                                    </div>
                                  </div>
                                  <div className="prodset-body">
                                    <div className="prodset-dt">
                                      <h5>Rejected Sheets:</h5>
                                      <p>{`${
                                        sheet.rejected_no_of_sheets
                                      } (${sheet.rejected_weight.toFixed(
                                        3
                                      )}) ${" "} ${
                                        sheet.units && sheet.units.weight
                                          ? capitalize(
                                              weightUnit[sheet.units.weight]
                                                ?.displayName
                                            )
                                          : "T"
                                      }`}</p>
                                    </div>
                                  </div>
                                </div>
                                <div className="prodset-footer">
                                  <label>Production Status</label>
                                  <span
                                    dataset={showProductionStatus(sheet.status)}
                                  >
                                    {showProductionStatus(sheet.status)}
                                  </span>
                                </div>
                                {sheet.status == "rejected" &&
                                  sheet.reel_type === "order" && (
                                    <div
                                      className="prodset-footer"
                                      style={{ marginTop: "-5px" }}
                                    >
                                      <label>
                                        Reason:{" "}
                                        {sheet.comments.length
                                          ? sheet.comments[
                                              sheet.comments.length - 1
                                            ]
                                          : " "}
                                      </label>
                                    </div>
                                  )}
                              </ProductionSet>
                            ))}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </Form>
              </DetailFields>
            </div>
          </RightDrawerContainer>
        </RightDrawerSidebar>
      ) : (
        <RightDrawerSidebar
          title={`Parent Set - ${parentReelDetails.id}`}
          visible={visible}
          onClose={onClose}
        >
          <RightDrawerContainer>
            <div className="resetPassForm removePadLeft">
              <DetailFields className="marginBtnP">
                <HaberForm>
                  <Form
                    form={form}
                    name="basic"
                    autoComplete="off"
                    className="haberLogin haberSignup"
                    style={{ marginTop: "0" }}
                  >
                    <div
                      className="drawerField"
                      style={{ paddingTop: "5px", paddingBottom: "10px" }}
                    >
                      <div className="titleWithText">
                        <h5 style={{ paddingBottom: "13px" }}>
                          General Details
                        </h5>
                        {parentReelDetails?.machine_type !== "cutter" && (
                          <p style={{ marginTop: "-10px" }}>
                            Reel / Core Diameter: {parentReelDetails.reel_od}{" "}
                            {parentReelDetails?.units &&
                            parentReelDetails?.units?.reel_od
                              ? lengthUnit[
                                  parentReelDetails.units.reel_od
                                ]?.displayName.toUpperCase()
                              : ""}
                            {" / "}
                            {parentReelDetails.core_id}{" "}
                            {parentReelDetails?.units &&
                            parentReelDetails?.units?.core_id
                              ? lengthUnit[
                                  parentReelDetails.units.core_id
                                ]?.displayName.toUpperCase()
                              : ""}
                          </p>
                        )}
                        <p style={{ marginTop: "-10px" }}>
                          Weight: {parentReelDetails.weight?.toFixed(3)}{" "}
                          {parentReelDetails?.units &&
                          parentReelDetails?.units?.parent_roll_weight
                            ? capitalize(
                                weightUnit[
                                  parentReelDetails.units.parent_roll_weight
                                ]?.displayName
                              )
                            : "T"}
                        </p>
                        <p style={{ marginTop: "-10px" }}>Mapped Jumbo:</p>
                        {/* <br /> */}
                        {parentReelDetails?.mapped_jumbo_reels_info?.map(
                          (item) => (
                            <p style={{ marginTop: "-10px" }}>
                              {`${item.number} (${
                                item.weight_utilized
                              } ${" "} ${
                                item?.units && item?.units?.weight_utilized
                                  ? capitalize(
                                      weightUnit[item.units.weight_utilized]
                                        ?.displayName
                                    )
                                  : "T"
                              })`}
                            </p>
                          )
                        )}
                      </div>
                    </div>
                    {(parentReelDetails.status === "mapped" ||
                      parentReelDetails.status === "produced") && (
                      <>
                        <div className="drawerField">
                          <div className="titleWithText">
                            <h5>Rewinding Date & Shift</h5>
                            <p>
                              The reel was rewinded on selected date and shift
                            </p>
                          </div>
                          <Row className="centerAlign justifyCSBetween">
                            <Col span={12}>
                              <DatePickerY>
                                <Form.Item
                                  name="date"
                                  className="dBlock"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This is a mandatory field",
                                    },
                                  ]}
                                  initialValue={
                                    parentReelDetails.rewinding_date
                                      ? moment(
                                          parentReelDetails.rewinding_date,
                                          "YYYY-MM-DD"
                                        )
                                      : null
                                  }
                                >
                                  <DatePicker
                                    format={"DD-MM-YYYY"}
                                    disabledDate={(current) => {
                                      return (
                                        current &&
                                        current < moment().subtract(1, "day")
                                      );
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                                <p style={{ marginTop: "-24px" }}>Date</p>
                              </DatePickerY>
                            </Col>
                            <Col span={12}>
                              <div
                                className="boxFormType"
                                style={{
                                  marginTop: "3px",
                                  paddingLeft: "3px",
                                }}
                              >
                                <Form.Item
                                  name="Shift"
                                  rules={[{ required: true }]}
                                  className="dBlock"
                                  initialValue={
                                    parentReelDetails.rewinding_shift
                                  }
                                >
                                  <Input placeholder="Text" disabled />
                                </Form.Item>
                                <p style={{ marginTop: "-26px" }}>Shift</p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        {parentReelDetails.status === "produced" && (
                          <div className="drawerField">
                            <div className="titleWithText">
                              <h5>Production Completion Date</h5>
                              <p>
                                The production was closed on the selected date
                              </p>
                            </div>
                            <div className="boxFormType">
                              <DatePickerY>
                                <Form.Item
                                  name="completionDate"
                                  initialValue={
                                    parentReelDetails.production_date
                                      ? moment(
                                          parentReelDetails.production_date,
                                          "YYYY-MM-DD"
                                        )
                                      : null
                                  }
                                >
                                  <DatePicker format={"DD-MM-YYYY"} disabled />
                                </Form.Item>
                              </DatePickerY>
                            </div>
                          </div>
                        )}
                        <div className="drawerField">
                          <div className="titleWithText">
                            <h5>Reels</h5>
                            <p>
                              All the child reels of this parent reel can be
                              viewed here
                            </p>
                          </div>
                          <div className="prod-reelset">
                            {parentReelDetails?.reels?.map((reel, index) => (
                              <ProductionSet>
                                <div className="prodset-header">
                                  <Iconmoon
                                    icon="tissue-role"
                                    size={28}
                                    color="#EA655B"
                                  />
                                  <div className="prodleft-header">
                                    <h4>
                                      {reel.id}
                                      {reel.forced && (
                                        <span dataset="Priority">Priority</span>
                                      )}

                                      {reel.intermediate_reels && (
                                        <span
                                          style={{
                                            color: "#6a6866",
                                            backgroundColor: "#edebe9",
                                            marginTop: "auto",
                                          }}
                                        >
                                          Intermediate
                                        </span>
                                      )}
                                    </h4>
                                    {reel.reel_type == "order" &&
                                      reel.category != "so" && (
                                        <label>
                                          Delivery Date:{" "}
                                          {reel.delivery_date
                                            ? moment(reel.delivery_date).format(
                                                "DD-MM-YYYY"
                                              )
                                            : ""}
                                        </label>
                                      )}
                                  </div>
                                </div>
                                <div className="prodset-body">
                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>Reel Weight:</h5>
                                      <p>
                                        {reel.weight}{" "}
                                        {reel.units && reel?.units?.weight
                                          ? capitalize(
                                              weightUnit[reel.units.weight]
                                                ?.displayName
                                            )
                                          : "T"}
                                      </p>
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>Reel Size:</h5>
                                      {reel.reel_size}{" "}
                                      {reel?.units && reel?.units?.reel_size
                                        ? lengthUnit[
                                            reel.units.reel_size
                                          ]?.displayName?.toUpperCase()
                                        : "CM"}
                                    </div>
                                  </div>
                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>Length:</h5>
                                      {reel.reel_length}{" "}
                                      {reel?.units && reel?.units?.reel_length
                                        ? lengthUnit[
                                            reel.units.reel_length
                                          ]?.displayName?.toUpperCase()
                                        : "CM"}
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      {jobcardType === "multi_stage" ? (
                                        !reel.intermediate_reels ? (
                                          reel.reel_type == "order" ? (
                                            <>
                                              <h5>Order Size:</h5>
                                              {!reel.intermediate_reels ? (
                                                <p>
                                                  {reel.size}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.size
                                                    ? lengthUnit[
                                                        reel.units.size
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              ) : (
                                                <p>
                                                  {reel.width}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.width
                                                    ? lengthUnit[
                                                        reel.units.width
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                  {" x "}
                                                  {reel.length}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.length
                                                    ? lengthUnit[
                                                        reel.units.length
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              <h5>Stock Size:</h5>
                                              {reel.width > 0 &&
                                              reel.length > 0 ? (
                                                <p>
                                                  {reel.width}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.width
                                                    ? lengthUnit[
                                                        reel.units.width
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                  {" x "}
                                                  {reel.length}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.length
                                                    ? lengthUnit[
                                                        reel.units.length
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              ) : (
                                                <p>
                                                  {reel.size}{" "}
                                                  {reel?.units &&
                                                  reel?.units?.size
                                                    ? lengthUnit[
                                                        reel.units.size
                                                      ]?.displayName?.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              )}
                                            </>
                                          )
                                        ) : reel.cutting_pattern.length == 12 ||
                                          reel.cutting_pattern.length == 13 ||
                                          reel.cutting_pattern.length == 14 ? (
                                          <>
                                            <h5>Cutting Pattern:</h5>
                                            <p style={{ width: "101px" }}>
                                              {reel.cutting_pattern}
                                            </p>
                                          </>
                                        ) : (
                                          <>
                                            <h5>Cutting Pattern:</h5>
                                            <p style={{ width: "101px" }}>
                                              <Tooltip
                                                title={reel.cutting_pattern}
                                              >
                                                {" "}
                                                <span
                                                  style={{
                                                    display: "flex",
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  {reel.cutting_pattern[0] +
                                                    reel.cutting_pattern[1] +
                                                    reel.cutting_pattern[2] +
                                                    reel.cutting_pattern[3] +
                                                    reel.cutting_pattern[4] +
                                                    reel.cutting_pattern[5] +
                                                    "..."}{" "}
                                                </span>
                                              </Tooltip>
                                            </p>
                                          </>
                                        )
                                      ) : reel.reel_type == "order" ? (
                                        !reel.intermediate_reels ? (
                                          <>
                                            <h5>Order Size:</h5>
                                            <p>
                                              {reel.size}{" "}
                                              {reel?.units && reel?.units?.size
                                                ? lengthUnit[
                                                    reel.units.size
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                            </p>
                                          </>
                                        ) : (
                                          <>
                                            <h5>Order Size:</h5>
                                            <p>
                                              {reel.width}{" "}
                                              {reel?.units && reel?.units?.width
                                                ? lengthUnit[
                                                    reel.units.width
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                              {" x "}
                                              {reel.length}{" "}
                                              {reel?.units &&
                                              reel?.units?.length
                                                ? lengthUnit[
                                                    reel.units.length
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                            </p>
                                          </>
                                        )
                                      ) : reel.width > 0 && reel.length > 0 ? (
                                        <>
                                          <h5>Stock Size:</h5>
                                          <p>
                                            {reel.width}{" "}
                                            {reel?.units && reel?.units?.width
                                              ? lengthUnit[
                                                  reel.units.width
                                                ]?.displayName?.toUpperCase()
                                              : "CM"}
                                            {" x "}
                                            {reel.length}{" "}
                                            {reel?.units && reel?.units?.length
                                              ? lengthUnit[
                                                  reel.units.length
                                                ]?.displayName?.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </>
                                      ) : (
                                        <>
                                          <h5>Stock Size:</h5>
                                          <p>
                                            {reel.size}{" "}
                                            {reel?.units && reel?.units?.size
                                              ? lengthUnit[
                                                  reel.units.size
                                                ]?.displayName?.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </>
                                      )}
                                    </div>
                                  </div>

                                  {jobcardType === "multi_stage" ? (
                                    !reel.intermediate_reels ? (
                                      reel.reel_type == "order" ? (
                                        <div className="d-flex prodset-sb">
                                          <div className="prodset-dt prod-50">
                                            <h5>PO/SO NO.:</h5>
                                            {/* <p>{reel.po}</p> */}
                                            {reel?.po?.length > 11 ? (
                                              <Tooltip
                                                placement="bottomLeft"
                                                title={reel?.po}
                                              >
                                                <p>
                                                  {reel?.po?.slice(0, 12) +
                                                    "..."}
                                                </p>
                                              </Tooltip>
                                            ) : (
                                              <p>{reel?.po}</p>
                                            )}
                                            {reel?.so?.length > 11 ? (
                                              <Tooltip
                                                placement="bottomLeft"
                                                title={reel?.so}
                                              >
                                                <p>
                                                  {reel?.so?.slice(0, 12) +
                                                    "..."}
                                                </p>
                                              </Tooltip>
                                            ) : (
                                              <p>{reel?.so}</p>
                                            )}
                                          </div>
                                          <div className="prodset-dt prod-50">
                                            <h5>ORDER NO.:</h5>
                                            <p>{reel.order}</p>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="prodset-dt">
                                          <h5>STOCK NO.:</h5>
                                          <p>{`${reel.stock}`}</p>
                                        </div>
                                      )
                                    ) : (
                                      <>
                                        <div className="d-flex prodset-sb">
                                          <div className="prodset-dt prod-50">
                                            <h5>PO/SO NO.:</h5>
                                            {/* <p>{reel.po}</p> */}
                                            <p>
                                              {[
                                                ...(reel?.po || []),
                                                ...(reel?.so || []),
                                              ]
                                                .slice(0, 2)
                                                .map((item, index) => (
                                                  <div key={index}>
                                                    {item?.length > 11 ? (
                                                      <Tooltip
                                                        placement="bottomLeft"
                                                        title={item}
                                                      >
                                                        <p>
                                                          {item.slice(0, 12)}
                                                          ...,
                                                        </p>
                                                      </Tooltip>
                                                    ) : (
                                                      <p>{item},</p>
                                                    )}
                                                  </div>
                                                ))}

                                              {[
                                                ...(reel?.po || []),
                                                ...(reel?.so || []),
                                              ].length > 2 && (
                                                <Tooltip
                                                  title={[
                                                    ...(reel?.po || []),
                                                    ...(reel?.so || []),
                                                  ]
                                                    .slice(2)
                                                    .join(", ")}
                                                >
                                                  <span
                                                    style={{
                                                      display: "flex",
                                                      fontSize: "10px",
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    &{" "}
                                                    {[
                                                      ...(reel?.po || []),
                                                      ...(reel?.so || []),
                                                    ].length - 2}{" "}
                                                    More
                                                  </span>
                                                </Tooltip>
                                              )}
                                            </p>
                                          </div>
                                          <div className="prodset-dt prod-50">
                                            <h5>ORDER NO.:</h5>
                                            {/* <p>{reel.order}</p> */}
                                            <p>
                                              {reel?.order &&
                                                reel?.order?.map(
                                                  (item, index) => {
                                                    return (
                                                      index < 2 && (
                                                        <div>
                                                          {item}{" "}
                                                          {index == 1
                                                            ? "...,"
                                                            : reel?.order
                                                                ?.length > 1
                                                            ? ","
                                                            : ""}
                                                        </div>
                                                      )
                                                    );
                                                  }
                                                )}

                                              {reel?.order &&
                                                reel?.order?.length >= 2 &&
                                                reel.order?.map(
                                                  (item, index) => {
                                                    let tooltipData = "";
                                                    for (
                                                      let index = 2;
                                                      index <
                                                      reel.order?.length;
                                                      index++
                                                    ) {
                                                      const data =
                                                        reel.order[index];
                                                      tooltipData =
                                                        tooltipData +
                                                        data +
                                                        ", ";
                                                    }
                                                    tooltipData =
                                                      tooltipData.substring(
                                                        0,
                                                        tooltipData.length - 1
                                                      );
                                                    return (
                                                      index == 2 && (
                                                        <Tooltip
                                                          title={tooltipData}
                                                        >
                                                          {" "}
                                                          <span
                                                            style={{
                                                              display: "flex",
                                                              fontSize: "10px",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                          >
                                                            &{" "}
                                                            {reel.order.length -
                                                              2}{" "}
                                                            More
                                                          </span>
                                                        </Tooltip>
                                                      )
                                                    );
                                                  }
                                                )}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="prodset-dt">
                                          <h5>STOCK NO.:</h5>
                                          {/* <p>{`${reel.stock}`}</p> */}
                                          <p>
                                            {reel?.stock &&
                                              reel?.stock?.map(
                                                (item, index) => {
                                                  return (
                                                    index < 2 && (
                                                      <div>
                                                        {item}{" "}
                                                        {index == 1
                                                          ? "...,"
                                                          : reel?.stock
                                                              ?.length > 1
                                                          ? ","
                                                          : ""}
                                                      </div>
                                                    )
                                                  );
                                                }
                                              )}

                                            {reel?.stock &&
                                              reel?.stock?.length >= 2 &&
                                              reel.stock?.map((item, index) => {
                                                let tooltipData = "";
                                                for (
                                                  let index = 2;
                                                  index < reel.stock?.length;
                                                  index++
                                                ) {
                                                  const data =
                                                    reel.stock[index];
                                                  tooltipData =
                                                    tooltipData + data + ", ";
                                                }
                                                tooltipData =
                                                  tooltipData.substring(
                                                    0,
                                                    tooltipData.length - 1
                                                  );
                                                return (
                                                  index == 2 && (
                                                    <Tooltip
                                                      title={tooltipData}
                                                    >
                                                      {" "}
                                                      <span
                                                        style={{
                                                          display: "flex",
                                                          fontSize: "10px",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        &{" "}
                                                        {reel.stock.length - 2}{" "}
                                                        More
                                                      </span>
                                                    </Tooltip>
                                                  )
                                                );
                                              })}
                                          </p>
                                        </div>
                                      </>
                                    )
                                  ) : reel.reel_type == "order" ? (
                                    <div className="d-flex prodset-sb">
                                      <div className="prodset-dt prod-50">
                                        <h5>PO/SO NO.:</h5>
                                        {reel?.po?.length > 11 ? (
                                          <Tooltip
                                            placement="bottomLeft"
                                            title={reel?.po}
                                          >
                                            <p>
                                              {reel?.po?.slice(0, 12) + "..."}
                                            </p>
                                          </Tooltip>
                                        ) : (
                                          <p>{reel?.po}</p>
                                        )}
                                        {reel?.so?.length > 11 ? (
                                          <Tooltip
                                            placement="bottomLeft"
                                            title={reel?.so}
                                          >
                                            <p>
                                              {reel?.so?.slice(0, 12) + "..."}
                                            </p>
                                          </Tooltip>
                                        ) : (
                                          <p>{reel?.so}</p>
                                        )}
                                      </div>
                                      <div className="prodset-dt prod-50">
                                        <h5>ORDER NO.:</h5>
                                        <p>{reel.order}</p>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="prodset-dt">
                                      <h5>STOCK NO.:</h5>
                                      <p>{`${reel.stock}`}</p>
                                    </div>
                                  )}

                                  {jobcardType === "multi_stage" ? (
                                    !reel.intermediate_reels ? (
                                      <div className="d-flex prodset-sb">
                                        <div className="prodset-dt prod-50">
                                          <h5>CX:</h5>
                                          <p>{reel.customer} </p>
                                        </div>
                                        <div className="prodset-dt prod-50">
                                          <h5>CNEE:</h5>
                                          <p>{reel.consignee}</p>
                                        </div>
                                      </div>
                                    ) : (
                                      // (reel.reel_type == "order" ? (
                                      <div className="d-flex prodset-sb">
                                        <div className="prodset-dt prod-50">
                                          <h5>CX:</h5>
                                          {/* <p>{reel.customer}{" "}</p> */}
                                          <p>
                                            {reel?.customer &&
                                              reel?.customer?.map(
                                                (item, index) => {
                                                  return (
                                                    index < 2 && (
                                                      <div>
                                                        {item}{" "}
                                                        {index == 1
                                                          ? "...,"
                                                          : reel?.customer
                                                              ?.length > 1
                                                          ? ","
                                                          : ""}
                                                      </div>
                                                    )
                                                  );
                                                }
                                              )}

                                            {reel?.customer &&
                                              reel?.customer?.length >= 2 &&
                                              reel.customer?.map(
                                                (item, index) => {
                                                  let tooltipData = "";
                                                  for (
                                                    let index = 2;
                                                    index <
                                                    reel.customer?.length;
                                                    index++
                                                  ) {
                                                    const data =
                                                      reel.customer[index];
                                                    tooltipData =
                                                      tooltipData + data + ", ";
                                                  }
                                                  tooltipData =
                                                    tooltipData.substring(
                                                      0,
                                                      tooltipData.length - 1
                                                    );
                                                  return (
                                                    index == 2 && (
                                                      <Tooltip
                                                        title={tooltipData}
                                                      >
                                                        {" "}
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            fontSize: "10px",
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          &{" "}
                                                          {reel.customer
                                                            .length - 2}{" "}
                                                          More
                                                        </span>
                                                      </Tooltip>
                                                    )
                                                  );
                                                }
                                              )}
                                          </p>
                                        </div>
                                        <div className="prodset-dt prod-50">
                                          <h5>CNEE:</h5>
                                          {/* <p>{reel.consignee}</p> */}
                                          <p>
                                            {reel?.consignee &&
                                              reel?.consignee?.map(
                                                (item, index) => {
                                                  return (
                                                    index < 2 && (
                                                      <div>
                                                        {item}{" "}
                                                        {index == 1
                                                          ? "...,"
                                                          : reel?.consignee
                                                              ?.length > 1
                                                          ? ","
                                                          : ""}
                                                      </div>
                                                    )
                                                  );
                                                }
                                              )}

                                            {reel?.consignee &&
                                              reel?.consignee?.length >= 2 &&
                                              reel.consignee?.map(
                                                (item, index) => {
                                                  let tooltipData = "";
                                                  for (
                                                    let index = 2;
                                                    index <
                                                    reel.consignee?.length;
                                                    index++
                                                  ) {
                                                    const data =
                                                      reel.consignee[index];
                                                    tooltipData =
                                                      tooltipData + data + ", ";
                                                  }
                                                  tooltipData =
                                                    tooltipData.substring(
                                                      0,
                                                      tooltipData.length - 1
                                                    );
                                                  return (
                                                    index == 2 && (
                                                      <Tooltip
                                                        title={tooltipData}
                                                      >
                                                        {" "}
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            fontSize: "10px",
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          &{" "}
                                                          {reel.consignee
                                                            .length - 2}{" "}
                                                          More
                                                        </span>
                                                      </Tooltip>
                                                    )
                                                  );
                                                }
                                              )}
                                          </p>
                                        </div>
                                      </div>
                                      // ) : (""))
                                    )
                                  ) : reel.reel_type == "order" ? (
                                    <div className="d-flex prodset-sb">
                                      <div className="prodset-dt prod-50">
                                        <h5>CX:</h5>
                                        <p>{reel.customer} </p>
                                      </div>
                                      <div className="prodset-dt prod-50">
                                        <h5>CNEE:</h5>
                                        <p>{reel.consignee}</p>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>Rewinding Position:</h5>
                                      <p>{reel.position} </p>
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>Reel No.:</h5>
                                      <p>{reel.number}</p>
                                    </div>
                                  </div>

                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>Dispatch Date:{""}</h5>
                                      <p>
                                        {reel.dispatch_date
                                          ? moment(reel.dispatch_date).format(
                                              "DD-MM-YYYY"
                                            )
                                          : ""}
                                      </p>
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>Produced:</h5>
                                      <p>
                                        {reel.produced_weight
                                          ? reel.produced_weight +
                                            " " +
                                            (reel.units &&
                                            reel?.units?.produced_weight
                                              ? capitalize(
                                                  weightUnit[
                                                    reel.units.produced_weight
                                                  ]?.displayName
                                                )
                                              : "T")
                                          : " "}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="removeStar"
                                  style={{ marginTop: "22px" }}
                                >
                                  <Row style={{ marginTop: "-15px" }}>
                                    <div>
                                      <Col>
                                        <Form.Item
                                          name={`coreWeight${index}`}
                                          className="dBlock"
                                          initialValue={
                                            reel?.includes_core_weight
                                          }
                                        >
                                          <Checkbox
                                            // onChange={(e) =>
                                            //   onCoreWeightCheck(e, index)
                                            // }
                                            checked={reel?.includes_core_weight}
                                            disabled
                                          ></Checkbox>
                                          <span
                                            style={{
                                              marginLeft: "10px",
                                              fontSize: "13px",
                                              fontFamily:
                                                "var(--sf-pro-display-m)",
                                              color: "#5b5a58",
                                            }}
                                          >
                                            Produced quantity includes core
                                            weight
                                          </span>
                                        </Form.Item>
                                      </Col>
                                    </div>
                                  </Row>
                                  <Row
                                    style={{
                                      marginTop: "-28px",
                                      marginBottom:
                                        reel[index]?.status != "rejected" &&
                                        "-19px",
                                    }}
                                  >
                                    <div>
                                      <Col>
                                        <Form.Item
                                          name={`packagingWeight${index}`}
                                          className="dBlock"
                                          initialValue={
                                            reel?.includes_packaging_weight
                                          }
                                        >
                                          <Checkbox
                                            // onChange={(e) =>
                                            //   onPackagingWeightCheck(e, index)
                                            // }
                                            checked={
                                              reel?.includes_packaging_weight
                                            }
                                            disabled
                                          ></Checkbox>
                                          <span
                                            style={{
                                              marginLeft: "10px",
                                              fontSize: "13px",
                                              fontFamily:
                                                "var(--sf-pro-display-m)",
                                              color: "#5b5a58",
                                            }}
                                          >
                                            Produced quantity includes packaging
                                            weight
                                          </span>
                                        </Form.Item>
                                      </Col>
                                    </div>
                                  </Row>
                                </div>
                                <div
                                  className="prodset-footer"
                                  style={{ marginTop: "-30px" }}
                                >
                                  <label>Production Status</label>
                                  <span
                                    dataset={showProductionStatus(reel.status)}
                                  >
                                    {showProductionStatus(reel.status)}
                                  </span>
                                </div>
                                {reel.status == "rejected" &&
                                  reel.reel_type === "order" && (
                                    <div
                                      className="prodset-footer"
                                      style={{ marginTop: "-5px" }}
                                    >
                                      <label>
                                        Reason:{" "}
                                        {reel.comments.length
                                          ? reel.comments[
                                              reel.comments.length - 1
                                            ]
                                          : " "}
                                      </label>
                                    </div>
                                  )}
                              </ProductionSet>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                  </Form>
                </HaberForm>
              </DetailFields>
            </div>
          </RightDrawerContainer>
        </RightDrawerSidebar>
      )}
    </>
  ) : null;
};
export default JumboReelParentSetDrawer;
